import { render, staticRenderFns } from "./PagesList.vue?vue&type=template&id=45eab4af&scoped=true&"
import script from "./PagesList.vue?vue&type=script&lang=js&"
export * from "./PagesList.vue?vue&type=script&lang=js&"
import style0 from "./PagesList.vue?vue&type=style&index=0&id=45eab4af&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eab4af",
  null
  
)

export default component.exports